import React from "react"
import { useTranslation } from 'react-i18next'

// shift status -> i18n key; color comes from .tp-status-<status>
export const SHIFT_STATUSES = {
	pending: 'WAITING',
	open: 'SHIFT_OPENED',
	closed: 'SHIFT_CLOSED',
}

function ShiftStatus({ status }) {
	const { t } = useTranslation()

	if (!SHIFT_STATUSES[status]) return '-'

	return (
		<span className={`tp-status tp-status-${status}`}>
			<span className="tp-dot"></span>
			{t(SHIFT_STATUSES[status])}
		</span>
	)
}

export default ShiftStatus
